Array.prototype.remove = function (item) {
	const index = this.indexOf(item);

	if (index !== -1) {
		this.splice(index, 1);
	}

	return this;
};

Array.prototype.contains = function (item) {
	if (this === undefined || this === null) {
		return false;
	}

	return this.indexOf(item) !== -1;
};

Array.prototype.sum = function (fn) {

  let result = 0;
  for (var i = 0; i < this.length; ++i)
  {
      result += fn(this[i]);
  }

	return result;
};



/** WEBPACK FOOTER **
 ** ./public/app/natives.js
 **/